import react, { useState, useEffect, useRef } from "react";
import { Input, TextArea, Select, InputSearch } from '../../../../../Layout/Forms/Form';
import NightspotRequests from "../../../NightspotRequests";
import MapComponent from "../MapWrapper";
const PlaceSearch = ({ searchData, placeInfo }) => {
    const componentMounted = useRef(true);
    const [form, setForm] = useState({
        query: "",
        name: "",
        place_id: ""
    });
    const [googlePlaces, setGooglePlaces] = useState([]);
    const [InputSearchPredict, setInputSearchPredict] = useState(false);
    const [geometryMap, setGeometryMap] = useState({
        lat: "",
        lng: ""
    })





    //const [placeInfo, setPlaceInfo] = useState(formLocation);
    // useEffect(() => {
    //     if(formLocation && formLocation.length > 0){
    //         console.log(formLocation)
    //         setPlaceInfo(formLocation)
    //     }


    // }, [formLocation])






    // useEffect(() => {
    //     searchData(placeInfo);

    // }, [placeInfo])


    // handler inputs
    const handleChangeInputs = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    }

    useEffect(() => {
        if (form.query && form.query.length >= 3) {
            setForm({
                ...form,
                name: "",
                place_id: ""
            });
            getGooglePlacesPredict();
        }
        if (form.place_id && form.place_id.length > 0) {
            setTimeout(() => {
                setInputSearchPredict(false)
            }, 50);
        }
    }, [form.query])

    useEffect(() => {
        if (form.place_id && form.place_id.length > 0) {
            getGooglePlaceDetails()
        }
    }, [form.place_id])




    const getGooglePlacesPredict = async () => {
        let info = await NightspotRequests.getLocationQueryPlace(form.query);
        if (info.status) {
            setGooglePlaces(info.data);
            setInputSearchPredict(true);
        }
    }

    const handlerInputSerachPredict = (item) => {
        setForm({
            ...form,
            name: item.name,
            place_id: item.place_id
        });


    }


    const getGooglePlaceDetails = async () => {
        let info = await NightspotRequests.getLocationDetailPlace(form.place_id);
        if (info.status) {
            searchData(info.data);
            //setPlaceInfo(info.data);
        }
    }


    const GoogleMaps = () => {
        //return null;
        // console.log(placeInfo)

        let geometry_lat = parseFloat(placeInfo.geometry.lat);
        let geometry_lng = parseFloat(placeInfo.geometry.lng);

        return <MapComponent
            lat={geometry_lat}
            long={geometry_lng}
        />
    }

    return (
        <>
            <div className="row" style={{ marginTop: '50px' }}>
                <div className="col-12">
                    <h2>Detalhes da sua localização</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <InputSearch
                        label="Procurar o nome do seu estabelecimento ou morada"
                        name="query"
                        value={form.name.length === 0 ? form.query : form.name}
                        onChange={(e) => handleChangeInputs(e)}
                        predicts={googlePlaces}
                        onChangePredict={(e) => handlerInputSerachPredict(e)}
                        //isSelected={(form.place_id.length > 0) ? (false) : ((googlePlaces.length > 0) ? true : false)}
                        //isSelected={InputSearchPredict}
                        isSelected={(form.place_id.length > 0) ? (false) : true}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <h4>Endereço</h4>
                </div>
            </div>

            <div className="row mt-2">
                <div className="col-12">
                    <TextArea
                        label="Morada Completa"
                        name="adress"
                        value={placeInfo.formatted_address}
                        readOnly={true}
                        onChange={(e) => false}
                    />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-6">
                    <Input
                        label="Latitude"
                        name="lat"
                        value={placeInfo.geometry.lat}
                        readOnly={true}
                        onChange={(e) => false}
                    />
                </div>
                <div className="col-6">
                    <Input
                        label="Longitude"
                        name="lng"
                        value={placeInfo.geometry.lng}
                        readOnly={true}
                        onChange={(e) => false}
                    />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12">
                    <GoogleMaps />
                </div>
            </div>

        </>


    )
}

export default PlaceSearch;